import React from 'react';
import Sidebar from '../Sidebar/Sidebar';
import NavBar from '../NavBar/NavBar';
import './About.css';
import Fade from 'react-reveal/Fade';

const About = () => {
    return (
      <div className="container-fluid">
        <div className="row">
            <Sidebar></Sidebar>
            <div className="col-md-9 col-sm-12 col-12 bg-green-opacity main-area">
                <div className="header">
                  <div className="progress-container">
                    <div className="progress_bar" id="myBar"></div>
                  </div>
                </div> 
                <div className="container">
                  {/* About Area */}
                  <div className="row mb-5 about_me_area">
                    <Fade bottom>
                      <div className="btn-2 about_me_details col-md-10 bg-white shadow-lg rounded w-100 mt-5 mx-3">
                        <div className="row about_me">
                            <div className="col-md-12">
                              <h2 className="text-center h2-responsive text-white p-3">Hi, I'am Mowmita.</h2>
                              <h4 className="text-center h4-responsive">A Front End Engineer & JavaScript Developer</h4>
                              <p className="p-responsive text-center text-secondary mt-4">I am a self taught and passionate web developer currently working as an intern Web Developer at Molog Media and Advertising .I love to develop websites and web applications. I love to learn new technologies and can stick with it until it's achieved by me .I can solve the problem myself which helps me to enrich my knowledge preciously .I accepts my lacking and eagerly try to update myself .I am from CSE background. I eagerly want to learn and research more and more about new technologies and ready to face all kind of challenges with a view to establishing myself as someone with excellent creativity, professional skills and leadership abilities which I would love to implement in real life.</p>
                            </div>
                        </div>
                      </div>
                    </Fade>
                  </div>
                </div>
                <NavBar></NavBar>
            </div>
        </div>
      </div>
    );
};

export default About;